<template lang="pug">
    .pay-notification
        .pay-notification__container
            svg-icon(name="lock", :aria-hidden="true" size="xx-large")
            .pay-notification__text
                | {{ messageText }}
</template>

<script>
/* eslint-disable */
    export default {
        props: {
            needToPay: {
                type: Number,
                default: null
            },
            user: {
                type: Object,
                default: null
            }
        },
        computed: {
            messageText () {
                if (this.needToPay) {
                    return this.$i18n.t('common.common_payNotification', {
                        sex: this.$i18n.t('common.common_sex')[this.user.sex],
                        name: this.user.fullName,
                        sum: this.formatBalance(this.roundedNeedToPay())
                    })
                } else {
                    return this.$i18n.t('common.common_payNotification_newUsers')
                }

            }
        },
        methods: {
            formatBalance (balance) {
                const formatter = new Intl.NumberFormat('ru-RU', {
                    style: 'currency',
                    currency: 'RUB',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2
                })
                return formatter.format(balance)
            },
            roundedNeedToPay () {
                return Math.round(this.needToPay * 100) / 100
            }
        }
    }
</script>

<style lang="scss" scoped>
    .pay-notification {
        padding: 15px;
        box-sizing: border-box;
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-20;

        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-bottom: 5px;
    }

    .pay-notification__container {
        border: 2px solid $hsl_color_red-62;
        border-radius: 12px;
        padding: 30px;
        display: flex;
        align-items: center;
        .svg-icon {
            margin-right: 30px;
        }
        @media screen and (max-width: 767px) {
            flex-direction: column;
            .svg-icon {
                margin-right: 0;
                margin-bottom: 10px;
            }
        }
    }

    .pay-notification__text {
        text-align: center;
        font-size: 20px;
        @media screen and (max-width: 400px) {
            font-size: 16px;
        }
    }
</style>
